module.exports = __webpack_public_path__ + "static/media/прибранный домик 2.dad1d764.jpg";